import { create } from 'zustand';

const DEFAULT_THEME_NAME = 'light';
const DEFAULT_IS_FIXED = false;

interface Header {
  themeName: string;
  setThemeName: (themeName: string | undefined) => void;
  isFixed: boolean;
  setIsFixed: (isFixed: boolean) => void;
  isSearchOpen: boolean;
  setIsSearchOpen: (isSearchOpen: boolean) => void;
}

export const useHeader = create<Header>()((set) => ({
  themeName: DEFAULT_THEME_NAME,
  setThemeName: (themeName) =>
    set(() => ({
      themeName: themeName !== undefined ? themeName : DEFAULT_THEME_NAME,
    })),
  isFixed: DEFAULT_IS_FIXED,
  setIsFixed: (isFixed) =>
    set(() => ({ isFixed: isFixed || DEFAULT_IS_FIXED })),
  isSearchOpen: false,
  setIsSearchOpen: (isSearchOpen) => set(() => ({ isSearchOpen })),
}));
